import { SECOND } from './time.const';

export const GEOLOCATION_OPTIONS: PositionOptions = {
	maximumAge: Infinity,
	timeout: 5 * SECOND,
};
